import { Dayjs } from 'dayjs';

interface FormData {
	name: string;
	email: string;
	mobile: string;
	eventType: string;
	noOfPeople: string;
	address: string;
	area: string;
	functionDate: Dayjs | null; // Use Dayjs type
}

interface Errors {
	name?: string;
	email?: string;
	mobile?: string;
	eventType?: string;
	noOfPeople?: string;
	address?: string;
	area?: string;
	functionDate?: string;
}

const validate = (values: FormData): Errors => {
	const errors: Errors = {};

	const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	if (!values.name) {
		errors.name = 'Name is required';
	}
	if (!values.email) {
		errors.email = 'Email is required';
	} else {
		// Check for the '@' symbol
		if (!values.email.includes('@')) {
			errors.email = 'Email must contain "@" symbol';
		}
		// Check for the '.' symbol after the '@'
		else if (!values.email.includes('.', values.email.indexOf('@'))) {
			errors.email = 'Email must contain a domain (e.g., .com)';
		}
		// Full email pattern check
		else if (!emailPattern.test(values.email)) {
			errors.email = 'Invalid email address format';
		}
	}

	if (!values.mobile) {
		errors.mobile = 'Contact number is required';
	} else if (!/^[0-9]{10}$/.test(values.mobile)) {
		errors.mobile = 'Contact number must contain only digits';
	} else if (values.mobile.length !== 10) {
		errors.mobile = 'Contact number must be exactly 10 digits';
	}

	// if (!values.noOfPeople) {
	// 	errors.noOfPeople = 'Number of people is required';
	// }
	if (!values.noOfPeople) {
		errors.noOfPeople = 'Number of people is required';
	} else if (Number(values.noOfPeople) < 250) {
		errors.noOfPeople = 'Minimum 250 people required';
	}

	if (!values.address) {
		errors.address = 'Address is required';
	}

	if (!values.area) {
		errors.area = 'Area is required';
	}

	if (!values.functionDate) {
		errors.functionDate = 'Date is required';
	} else if (values.functionDate.toDate() < new Date()) {
		errors.functionDate = 'Date cannot be in the past';
	}

	return errors;
};

export default validate;
